module.exports = __webpack_public_path__ + "img/icon13.fa63c4ac.png";